import api from "./api";

class MailAPI {
  async cadastroSmtpMail(headers, params) {
    const response = await api({
      method: 'post',
      url: '/cadastro_smtp_mail',
      headers,
      data: params
    });
    return response;
  }

  async testarEnvioEmail (headers) {
    const response = await api.get("/testar_envio_email", { headers });
    return response;
  }

  async getConfiguracaoEmail (headers) {
    const response = await api.get("/get_configuracao_email", { headers });
    return response;
  }

  async verificarConfigsMailUsuario(headers) {
    const response = await api.get("/verificar_configs_mail_usuario", {
      headers
    });
    return response;
  }

  async enviarEmailCotacao(headers, params) {
    const response = await api({
      method: 'post',
      url: '/enviar_email_cotacao',
      headers,
      data: params
    });
    return response;
  }

  async getEmailUsuario (headers) {
    const response = await api.get("/get_email_usuario", { headers });
    return response;
  }
}

export default new MailAPI();
